import React from 'react'
import images from '../../constants/images'
import './CompPayment.css'

const CompPayment = () => {
    return (
        <div className="payment__competitive">
            <h4 className="h4__roboto" style={{ paddingLeft: '.5rem', paddingTop: '.5rem' }}>Playment for Fall & Spring</h4>
            <div className="view__competitive-payment" >
                <div className="comp__payment-info">
                <p className="p__opensans" style={{ margin: '0' }}>Please Include the Following in the Venmo Note:</p>
                <p className="p__opensans" style={{ margin: '0' }}>Competitive Age, Gender Group & First, Last Name of Child</p>
                <p className="p__opensans" style={{ margin: '0', marginBottom: '2rem' }}>Example: U12B John Smith</p>
                </div>
                <div className="view__qrcode" style={{ marginTop: '2rem' }}>
                    <img style={{ width: '10rem', }} className="venmoImg" src={images.venmo} alt="venmo" />
                    <p className="p__opensans" style={{ marginTop: '1rem', fontSize: '10px' }}>Payment Method - Venmo QR Code</p>
                </div>
            </div>
        </div>
    )
}

export default CompPayment